import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceScanResults = lazyWithPreload(
  () => import('./FaceScanResults'),
)
